import React, { FC, useEffect, useState } from 'react';
import { Form, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { FIELD_MODES } from '../../dadata-constants';
import { DadataField, ManualField } from './components';
import { useField } from 'formik';
import { IFIOInfo } from './fio-interfaces';
import { GenderField } from './components/GenderField';
import { GENDER_TYPES } from '.';
import { IUserProfileEditFrontend } from 'src/modules/users/widgets';

interface IFIOProps {
  name: string;
}

const GENDER_FIELD_NAME = 'gender';

export const FIOField: FC<IFIOProps> = ({ name }) => {
  const [mode, setMode] = useState<string>(FIELD_MODES.DADATA);
  const [{ value }, , { setValue, setTouched }] = useField(name);
  const [, , { setValue: setGender }] = useField(GENDER_FIELD_NAME);
  // Если мы присвоили пол из dadata,
  // при первом изменении в ручном режиме необходимо сбрасывать пол на неопределенный
  const [wasLastChangeInDadata, setWasLastChangeInDadata] = useState(false);

  useEffect(() => {
    if (!value?.dadataFio?.unrestrictedValue) {
      setMode(FIELD_MODES.MANUAL);
    }
  }, [value]);

  const handleChosenPerson = (fio: IFIOInfo): void => {
    setValue(fio);
    setTouched(true);
    setGender(fio.dadataFio.data.gender);
    setWasLastChangeInDadata(true);
  };

  const handleManualUpdate = (fioValue: IUserProfileEditFrontend.IFioObject): void => {
    const newValue = { ...value, ...fioValue };
    const manualValue = {
      ...newValue,
      dadataFio: { value: `${newValue.lastName || ''} ${newValue.firstName || ''} ${newValue.middleName || ''}` },
    };

    if (wasLastChangeInDadata) {
      setGender(GENDER_TYPES.UNKNOWN);
      setWasLastChangeInDadata(false);
    }

    setValue(manualValue);
  };

  return (
    <>
      <div className="mt-4 mb-4">
        <ToggleButtonGroup type="radio" name="fio-mode-toggle" value={mode} onChange={setMode} className="w-100">
          <ToggleButton variant="default" value={FIELD_MODES.DADATA}>
            Поиск ФИО
          </ToggleButton>
          <ToggleButton variant="default" value={FIELD_MODES.MANUAL}>
            Ручной ввод ФИО
          </ToggleButton>
        </ToggleButtonGroup>
      </div>

      <Form.Group>
        {mode === FIELD_MODES.MANUAL ? (
          <ManualField name={name} handleManualUpdate={handleManualUpdate} />
        ) : (
          <DadataField name={name} handleChosenPerson={handleChosenPerson} />
        )}
        <GenderField name={GENDER_FIELD_NAME} />
      </Form.Group>
    </>
  );
};
